import { CardFooter } from "reactstrap";
import { VariationOfAddonsCancel, VariationOfAddonsSubmit } from "../../../../Constant";
import { Btn } from "../../../../AbstractElements";

export const VariationOfAddonsCardFooter = () => {
    return (
        <CardFooter>
            <Btn color="primary" className="m-r-15">
                {VariationOfAddonsSubmit}
            </Btn>
            <Btn color="light" type="reset">
                {VariationOfAddonsCancel}
            </Btn>
        </CardFooter>
    );
};
